import React,{useState,useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import { projFirestore } from '../../firebase/config';
import RecipeList from '../../RecipeList';
function Search() {
  const getURL = useLocation().search;
  const URL_object = new URLSearchParams(getURL); //gives you an obj for all the params in url
  const query_in_url = URL_object.get('q') //getting param q from the url


  const [data, setData] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    setIsPending(true);
    
    const collectionRef = projFirestore.collection('recipes');
    collectionRef.get().then(docs => {
        let docArray = [];
       docs.forEach(doc => {
           if(doc.data().title.toLowerCase().includes(query_in_url.toLowerCase())) {
            docArray.push({id: doc.id, ...doc.data()})
           }
            
       })
       setIsPending(false);
       setData(docArray);
    }).catch(err=>{
      setError(err.message)
    })
}, [query_in_url])
  return (
    <div>
      <h2 className="page-title">Recipes Including: "{query_in_url}"</h2>
      {isPending && <p className='loading'>Loading data...</p>}
      {error && <p className='error'>{error}</p>}
      {data && <RecipeList recipes={data}/>}
    </div>
  )
}

export default Search